import React from "react";
import styles from "./MadeToMeasureReviewModal.module.scss";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import {
  MadeToMeasureConfiguration,
  RollerBlindConfiguration,
} from "../../configurationTypes";

type Props = {
  configuration: MadeToMeasureConfiguration;
  onClose: (e: React.SyntheticEvent) => void;
};

const RollerBlindsSelection = ({ configuration, onClose }: Props) => {
  const config = configuration as RollerBlindConfiguration;

  return (
    <>
      <li data-testid="m2m-review-config-window-fitting">
        <img
          className={styles.ReviewContent__image}
          src={
            config.recess === "Inside recess"
              ? "https://static.johnlewiscontent.com/v1/static/blind-inside-recess"
              : "https://static.johnlewiscontent.com/v1/static/blind-outside-recess"
          }
          data-testid="m2m-review-config-recess-image"
        />
        <div>
          <p className={styles.ReviewContent__title}>Window Fitting</p>
          <p data-testid="m2m-review-config-recess-description">
            {config.recess}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roller-blinds-window-fitting"
            >
              edit
            </UnderlinedButton>
          </p>
          <p className={styles.ReviewContent__title}>Chain side</p>
          <p data-testid="m2m-review-config-chain-side">
            {config.chainSide}{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roller-blinds-window-fitting"
            >
              edit
            </UnderlinedButton>
          </p>
          <p className={styles.ReviewContent__title}>Measurements</p>
          <p data-testid="m2m-review-config-measurements">
            {config.width}cm (w) x {config.height}cm (h){" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roller-blinds-measurements"
            >
              edit
            </UnderlinedButton>
          </p>
          <p className={styles.ReviewContent__title}>Installation height</p>
          <p data-testid="m2m-review-config-installation-height">
            {config.installationHeight}cm{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roller-blinds-measurements"
            >
              edit
            </UnderlinedButton>
          </p>
        </div>
      </li>
      <li data-testid="m2m-review-config-roll-direction">
        <img
          className={styles.ReviewContent__image}
          src={
            config.rollDirection === "Standard"
              ? "https://static.johnlewiscontent.com/v1/static/blind-standard-roll"
              : "https://static.johnlewiscontent.com/v1/static/blind-reverse-roll"
          }
          data-testid="m2m-review-config-roll-direction-image"
        />
        <div>
          <p className={styles.ReviewContent__title}>Roll Direction</p>
          <p data-testid="m2m-review-config-roll-direction-description">
            {config.rollDirection} roll{" "}
            <UnderlinedButton
              tag="a"
              type="button"
              onClick={onClose}
              href="#accordion-m2m-roller-blinds-roll-direction"
            >
              edit
            </UnderlinedButton>
          </p>
        </div>
      </li>
      <li data-testid="m2m-review-config-safety-info">
        <p>
          Your custom roller blind will be operated using a child-safe*,
          break-away side chain mechanism in chain colour{" "}
          <strong>Chrome</strong>.
        </p>
        <p>* Complies with EU child safety regulations</p>
      </li>
    </>
  );
};

export default RollerBlindsSelection;
